import { ICloneType } from "src/@types/cloneTypes";
import { ICountry } from "src/@types/country";
import { ISelectOption } from "src/@types/form";
import { IIndustry } from "src/@types/industry";
import { ISoldInformation } from "src/@types/soldInformation";

//CHANGE - TEMP UTILITY

type Data = ISoldInformation | IIndustry | ICloneType;

// function overloads
export function convertToOption(data: Data): ISelectOption;
export function convertToOption(data: Data[]): ISelectOption[];

export function convertToOption(
  data: Data | Data[]
): ISelectOption | ISelectOption[] {
  const convertSingleData = (data: Data): ISelectOption => ({
    id: data.id.toString(),
    value: data.slug,
    label: data.title,
  });

  if (Array.isArray(data)) {
    return data.map(convertSingleData);
  }
  return convertSingleData(data);
}

// function overloads
export function convertContryToOption(country: ICountry): ISelectOption;
export function convertContryToOption(country: ICountry[]): ISelectOption[];

export function convertContryToOption(country: ICountry | ICountry[]) {
  const convertSingleCountry = (country: ICountry): ISelectOption => ({
    id: country.id.toString(),
    value: country.slug,
    label: country.name,
    icon: country.icon,
  });
  if (Array.isArray(country)) {
    return country.map(convertSingleCountry);
  }
  return convertSingleCountry(country);
}
